import React, { useState, useEffect } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "حاسبة الدونات - احسب سعرات ودهون وسكريات الدونات بدقة";
const DESCRIPTION =
  "حاسبة الدونات المجانية - احسب السعرات الحرارية والدهون والسكريات والكربوهيدرات في الدونات بحسب نوعها وحجمها. أداة مثالية لمتابعة نظامك الغذائي.";
const KEYWORDS =
  "حاسبة الدونات, سعرات الدونات, دونات سعرات حرارية, كالوري الدونات, دهون الدونات, سكر الدونات, حاسبة الحلويات, donut calories calculator, donut nutrition";
const OG_URL = "https://do-calculate.com/calculator/ar/donut/";

const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "حاسبة الدونات",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "الرئيسية",
        item: "https://do-calculate.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "الحاسبات",
        item: "https://do-calculate.com/ar/all-calculators/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "حاسبة الدونات",
        item: OG_URL,
      },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "كم سعرة حرارية في الدونات المحلى بالجلاز؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "الدونات المحلى بالجلاز يحتوي على حوالي 190-240 سعرة حرارية للحجم المتوسط، مع نحو 10-12 جرام دهون و22-30 جرام كربوهيدرات. يختلف الرقم بحسب الحجم والماركة.",
        },
      },
      {
        "@type": "Question",
        name: "هل الدونات بالكريمة يحتوي على سعرات أكثر من الدونات العادي؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "نعم، الدونات المحشو بالكريمة أو الجيلي يحتوي عادةً على 300-400 سعرة حرارية، أي أعلى بكثير من الدونات السادة. الحشوة تضيف دهوناً وسكريات إضافية.",
        },
      },
      {
        "@type": "Question",
        name: "ما هو أقل أنواع الدونات سعرات حرارية؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "الدونات السادة أو المرشوش بالسكر هو الأخف سعرات، يتراوح بين 170-220 سعرة. أما دونات الحفرة (donut holes) فهو أخف بسبب صغر حجمه، إذ يحتوي على 60-100 سعرة فقط.",
        },
      },
    ],
  },
];

// Donut types with nutritional data per 100g
const DONUT_TYPES = {
  glazed: {
    name: "دونات بالجلاز",
    calories: 380,
    fat: 17,
    saturatedFat: 7,
    carbs: 52,
    sugar: 22,
    protein: 5,
    sodium: 280,
    fiber: 1,
    weightG: 60,
  },
  chocolate_glazed: {
    name: "دونات بالجلاز الشوكولاتة",
    calories: 400,
    fat: 20,
    saturatedFat: 9,
    carbs: 52,
    sugar: 28,
    protein: 5,
    sodium: 290,
    fiber: 1.5,
    weightG: 75,
  },
  plain: {
    name: "دونات سادة",
    calories: 350,
    fat: 15,
    saturatedFat: 6,
    carbs: 48,
    sugar: 12,
    protein: 5,
    sodium: 260,
    fiber: 1,
    weightG: 55,
  },
  sugar: {
    name: "دونات بالسكر",
    calories: 390,
    fat: 17,
    saturatedFat: 7,
    carbs: 55,
    sugar: 20,
    protein: 5,
    sodium: 280,
    fiber: 1,
    weightG: 60,
  },
  powdered_sugar: {
    name: "دونات بالسكر الناعم",
    calories: 395,
    fat: 18,
    saturatedFat: 7.5,
    carbs: 54,
    sugar: 21,
    protein: 5,
    sodium: 280,
    fiber: 1,
    weightG: 65,
  },
  cream_filled: {
    name: "دونات بالكريمة",
    calories: 420,
    fat: 22,
    saturatedFat: 10,
    carbs: 52,
    sugar: 25,
    protein: 5,
    sodium: 300,
    fiber: 0.5,
    weightG: 85,
  },
  jelly: {
    name: "دونات بالجيلي",
    calories: 410,
    fat: 18,
    saturatedFat: 7,
    carbs: 58,
    sugar: 30,
    protein: 5,
    sodium: 290,
    fiber: 0.5,
    weightG: 85,
  },
  frosted: {
    name: "دونات بالفروستنج",
    calories: 430,
    fat: 21,
    saturatedFat: 9,
    carbs: 58,
    sugar: 32,
    protein: 5,
    sodium: 300,
    fiber: 0.5,
    weightG: 75,
  },
  old_fashioned: {
    name: "دونات أولد فاشند",
    calories: 450,
    fat: 22,
    saturatedFat: 10,
    carbs: 58,
    sugar: 22,
    protein: 6,
    sodium: 310,
    fiber: 1,
    weightG: 80,
  },
  donut_hole: {
    name: "دونات حفرة (donut hole)",
    calories: 370,
    fat: 16,
    saturatedFat: 6,
    carbs: 51,
    sugar: 18,
    protein: 5,
    sodium: 270,
    fiber: 1,
    weightG: 25,
  },
};

const SIZE_MULTIPLIERS = {
  mini: { name: "صغير جداً (mini)", multiplier: 0.5 },
  small: { name: "صغير", multiplier: 0.75 },
  medium: { name: "متوسط", multiplier: 1.0 },
  large: { name: "كبير", multiplier: 1.35 },
  extra_large: { name: "كبير جداً", multiplier: 1.7 },
};

function DonutCalculator() {
  const [donutType, setDonutType] = useState("glazed");
  const [size, setSize] = useState("medium");
  const [quantity, setQuantity] = useState(1);
  const [customWeight, setCustomWeight] = useState("");
  const [useCustomWeight, setUseCustomWeight] = useState(false);
  const [dailyCalories, setDailyCalories] = useState(2000);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const calculateResult = () => {
    try {
      setError("");
      const donut = DONUT_TYPES[donutType];
      const sizeMultiplier = SIZE_MULTIPLIERS[size].multiplier;

      let weightGrams;
      if (useCustomWeight && customWeight) {
        weightGrams = parseFloat(customWeight);
        if (isNaN(weightGrams) || weightGrams <= 0) {
          setError("يرجى إدخال وزن صحيح أكبر من صفر");
          setResult(null);
          return;
        }
      } else {
        weightGrams = donut.weightG * sizeMultiplier;
      }

      const qty = parseInt(quantity) || 1;
      const factor = weightGrams / 100;

      const caloriesPerPiece = donut.calories * factor;
      const fatPerPiece = donut.fat * factor;
      const saturatedFatPerPiece = donut.saturatedFat * factor;
      const carbsPerPiece = donut.carbs * factor;
      const sugarPerPiece = donut.sugar * factor;
      const proteinPerPiece = donut.protein * factor;
      const sodiumPerPiece = donut.sodium * factor;
      const fiberPerPiece = donut.fiber * factor;

      const totalCalories = caloriesPerPiece * qty;
      const totalFat = fatPerPiece * qty;
      const totalSaturatedFat = saturatedFatPerPiece * qty;
      const totalCarbs = carbsPerPiece * qty;
      const totalSugar = sugarPerPiece * qty;
      const totalProtein = proteinPerPiece * qty;
      const totalSodium = sodiumPerPiece * qty;
      const totalFiber = fiberPerPiece * qty;

      const dailyCaloriesPercent = (totalCalories / dailyCalories) * 100;
      const dailyFatPercent = (totalFat / 78) * 100; // based on 2000 cal diet 78g fat
      const dailySugarPercent = (totalSugar / 50) * 100; // 50g daily sugar limit

      // Macro distribution
      const fatCalories = totalFat * 9;
      const carbCalories = totalCarbs * 4;
      const proteinCalories = totalProtein * 4;
      const totalMacroCalories = fatCalories + carbCalories + proteinCalories;

      const fatPercent = (fatCalories / totalMacroCalories) * 100;
      const carbPercent = (carbCalories / totalMacroCalories) * 100;
      const proteinPercent = (proteinCalories / totalMacroCalories) * 100;

      setResult({
        weightGrams,
        qty,
        donutName: donut.name,
        sizeName: SIZE_MULTIPLIERS[size].name,
        caloriesPerPiece,
        totalCalories,
        totalFat,
        totalSaturatedFat,
        totalCarbs,
        totalSugar,
        totalProtein,
        totalSodium,
        totalFiber,
        dailyCaloriesPercent,
        dailyFatPercent,
        dailySugarPercent,
        fatPercent,
        carbPercent,
        proteinPercent,
      });
    } catch (err) {
      setError("خطأ في الحساب: " + err.message);
      setResult(null);
    }
  };

  useEffect(() => {
    calculateResult();
  }, [donutType, size, quantity, customWeight, useCustomWeight, dailyCalories]);

  const handleClear = () => {
    setDonutType("glazed");
    setSize("medium");
    setQuantity(1);
    setCustomWeight("");
    setUseCustomWeight(false);
    setDailyCalories(2000);
    setResult(null);
    setError("");
  };

  return (
    <div className="rtl" style={{ direction: "rtl" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={SCHEMA}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "5px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>حاسبة الدونات</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            {/* Introduction */}
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <strong>حاسبة الدونات</strong> أداة مجانية ودقيقة تساعدك على{" "}
                <strong>حساب السعرات الحرارية</strong> والدهون والسكريات
                والكربوهيدرات في الدونات بحسب نوعها وحجمها وعددها. سواء كنت
                تتابع نظامك الغذائي أو مجرد فضولي لمعرفة ما تأكله، هذه الأداة
                تعطيك إجابة فورية ودقيقة.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />
            {/* Calculator Section */}
            <div className="calculatorStyle mb-4">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>
                  احسب سعرات الدونات الخاص بك
                </h2>
              </div>

              {/* Donut Type */}
              <div className="row">
                <div className="col-sm-12">
                  <label htmlFor="donutType" >
                    نوع الدونات
                  </label>
                  <select
                    id="donutType"
                    className="form-select"
                    value={donutType}
                    onChange={(e) => setDonutType(e.target.value)}
                  >
                    {Object.entries(DONUT_TYPES).map(([key, val]) => (
                      <option key={key} value={key}>
                        {val.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Size */}
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <label htmlFor="size" >
                    الحجم
                  </label>
                  <select
                    id="size"
                    className="form-select"
                    value={size}
                    onChange={(e) => setSize(e.target.value)}
                    disabled={useCustomWeight}
                  >
                    {Object.entries(SIZE_MULTIPLIERS).map(([key, val]) => (
                      <option key={key} value={key}>
                        {val.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-sm-12 col-md-6">
                  <label htmlFor="quantity" >
                    العدد (قطعة)
                  </label>
                  <input
                    id="quantity"
                    type="number"
                    className="form-control"
                    value={quantity}
                    onChange={(e) =>
                      setQuantity(parseInt(e.target.value) || 1)
                    }
                    min="1"
                    max="50"
                    placeholder="العدد"
                  />
                </div>
              </div>

              {/* Custom Weight Toggle */}
              <div className="row">
                <div className="col-sm-12">
                  <div style={{ marginTop: "8px", marginBottom: "4px" }}>
                    <input
                      type="checkbox"
                      id="useCustomWeight"
                      checked={useCustomWeight}
                      onChange={(e) => setUseCustomWeight(e.target.checked)}
                      style={{ marginLeft: "8px" }}
                    />
                    <label
                      htmlFor="useCustomWeight"
                      style={{ cursor: "pointer" }}
                    >
                      أدخل الوزن يدوياً (جرام)
                    </label>
                  </div>
                </div>
              </div>

              {useCustomWeight && (
                <div className="row">
                  <div className="col-sm-12 col-md-6">
                    <label htmlFor="customWeight" >
                      وزن القطعة الواحدة (جرام)
                    </label>
                    <input
                      id="customWeight"
                      type="number"
                      className="form-control"
                      value={customWeight}
                      onChange={(e) => setCustomWeight(e.target.value)}
                      min="1"
                      step="1"
                      placeholder="مثال: 75"
                      style={{ backgroundColor: "#fff3cd" }}
                    />
                  </div>
                </div>
              )}

              {/* Daily Calories */}
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <label htmlFor="dailyCalories" >
                    احتياجك اليومي من السعرات (سعرة)
                  </label>
                  <input
                    id="dailyCalories"
                    type="number"
                    className="form-control"
                    value={dailyCalories}
                    onChange={(e) =>
                      setDailyCalories(parseInt(e.target.value) || 2000)
                    }
                    min="1000"
                    max="5000"
                    step="50"
                    placeholder="2000"
                  />
                </div>
              </div>

              {/* Buttons */}
              <div className="text-center mb-3 mt-4">
                <button
                  onClick={handleClear}
                  className="btn btn-secondary"
                  style={{
                    fontSize: "16px",
                    padding: "10px 30px",
                  }}
                >
                  امسح
                </button>
              </div>

              {/* Error Message */}
              {error && (
                <div className="alert alert-warning" role="alert">
                  <strong>تنبيه:</strong> {error}
                </div>
              )}

              {/* Results */}
              {result && (
                <div className="mt-4">
                  <h3
                    style={{
                      fontSize: "18px",
                      marginBottom: "15px",
                      textAlign: "center",
                    }}
                  >
                    <strong>النتيجة:</strong>
                  </h3>
                  {/* Main Results Table */}
                  <div className="mb-3">
                    <table className="table bmi-table" style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th
                            className="bmi-header"
                            style={{ textAlign: "center" }}
                          >
                            البيان
                          </th>
                          <th
                            className="bmi-header"
                            style={{ textAlign: "center" }}
                          >
                            القطعة الواحدة
                          </th>
                          <th
                            className="bmi-header"
                            style={{ textAlign: "center" }}
                          >
                            الإجمالي ({result.qty} قطعة)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ textAlign: "center" }}>
                            السعرات الحرارية
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              fontSize: "18px",
                              fontWeight: "bold",
                              color: "#1a5f3f",
                            }}
                          >
                            {result.caloriesPerPiece.toFixed(0)} سعرة
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              fontSize: "18px",
                              fontWeight: "bold",
                              color: "#0f3d28",
                            }}
                          >
                            {result.totalCalories.toFixed(0)} سعرة
                          </td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>الدهون</td>
                          <td style={{ textAlign: "center" }}>
                            {(result.totalFat / result.qty).toFixed(1)} جم
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {result.totalFat.toFixed(1)} جم
                          </td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>الدهون المشبعة</td>
                          <td style={{ textAlign: "center" }}>
                            {(result.totalSaturatedFat / result.qty).toFixed(1)} جم
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {result.totalSaturatedFat.toFixed(1)} جم
                          </td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>الكربوهيدرات</td>
                          <td style={{ textAlign: "center" }}>
                            {(result.totalCarbs / result.qty).toFixed(1)} جم
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {result.totalCarbs.toFixed(1)} جم
                          </td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>السكريات</td>
                          <td style={{ textAlign: "center" }}>
                            {(result.totalSugar / result.qty).toFixed(1)} جم
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {result.totalSugar.toFixed(1)} جم
                          </td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>البروتين</td>
                          <td style={{ textAlign: "center" }}>
                            {(result.totalProtein / result.qty).toFixed(1)} جم
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {result.totalProtein.toFixed(1)} جم
                          </td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>الألياف</td>
                          <td style={{ textAlign: "center" }}>
                            {(result.totalFiber / result.qty).toFixed(1)} جم
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {result.totalFiber.toFixed(1)} جم
                          </td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>الصوديوم</td>
                          <td style={{ textAlign: "center" }}>
                            {(result.totalSodium / result.qty).toFixed(0)} ملجم
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {result.totalSodium.toFixed(0)} ملجم
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="info-sections-container">
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>نسبة من احتياجك اليومي</strong>
                      </div>
                      <div className="info-section-body">
                        <ul
                          style={{ listStyle: "none", padding: 0, lineHeight: "2" }}
                        >
                          <li>
                            🔥 <strong>السعرات:</strong>{" "}
                            {result.dailyCaloriesPercent.toFixed(1)}% من{" "}
                            {dailyCalories} سعرة يومياً
                          </li>
                          <li>
                            🧈 <strong>الدهون:</strong>{" "}
                            {result.dailyFatPercent.toFixed(1)}% من الحد اليومي
                            الموصى به (78 جم)
                          </li>
                          <li>
                            🍬 <strong>السكر:</strong>{" "}
                            {result.dailySugarPercent.toFixed(1)}% من الحد اليومي
                            الموصى به (50 جم)
                          </li>
                        </ul>
                        <div
                          className="alert alert-info mt-3"
                          style={{ fontSize: "14px" }}
                        >
                          <strong>💡 معلومة:</strong> النوع:{" "}
                          {result.donutName} — الوزن:{" "}
                          {result.weightGrams.toFixed(0)} جم للقطعة
                        </div>
                      </div>
                    </div>
                    <div className="info-section">
                      <div className="info-section-header">
                        <strong>توزيع العناصر الغذائية</strong>
                      </div>
                      <div className="info-section-body">
                        <div style={{ lineHeight: "1.8" }}>
                          <p>
                            <strong>الدهون:</strong>{" "}
                            {result.fatPercent.toFixed(1)}% من السعرات الكلية
                          </p>
                          <p>
                            <strong>الكربوهيدرات:</strong>{" "}
                            {result.carbPercent.toFixed(1)}% من السعرات الكلية
                          </p>
                          <p>
                            <strong>البروتين:</strong>{" "}
                            {result.proteinPercent.toFixed(1)}% من السعرات الكلية
                          </p>
                          <hr />
                          <p style={{ fontSize: "14px", color: "#666" }}>
                            <strong>طريقة الحساب:</strong>
                          </p>
                          <p style={{ fontSize: "14px", color: "#666" }}>
                            وزن القطعة = {result.weightGrams.toFixed(0)} جم
                            <br />
                            السعرات لكل 100 جم ={" "}
                            {DONUT_TYPES[donutType].calories} سعرة
                            <br />
                            السعرات للقطعة ={" "}
                            {result.caloriesPerPiece.toFixed(0)} سعرة
                            <br />
                            الإجمالي = {result.totalCalories.toFixed(0)} سعرة (
                            {result.qty} قطعة)
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            {/* Related Links */}
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>
      {/* Informational Content */}
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>ما هي حاسبة الدونات؟</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>حاسبة الدونات</strong> أداة غذائية مجانية تحسب لك
                  بدقة السعرات الحرارية والدهون والسكريات والكربوهيدرات في
                  الدونات. تختلف القيم الغذائية اختلافاً كبيراً بحسب نوع
                  الدونات وحجمه، لذا فهي ضرورية لمن يحسب سعراته أو يلتزم بنظام
                  غذائي محدد.
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  كيفية استخدام الحاسبة:
                </h3>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>اختر نوع الدونات من القائمة (جلاز، شوكولاتة، كريمة...)</li>
                  <li>حدد الحجم: صغير جداً أو متوسط أو كبير</li>
                  <li>أدخل عدد القطع التي تنوي أكلها</li>
                  <li>أدخل احتياجك اليومي من السعرات لمعرفة النسبة المئوية</li>
                  <li>يمكنك أيضاً إدخال وزن الدونات يدوياً إن كنت تعرفه بالضبط</li>
                  <li>ستظهر النتائج تلقائياً دون الحاجة للضغط على أي زر</li>
                </ol>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💡 ملاحظة:</strong> القيم الغذائية المستخدمة مبنية
                  على متوسطات موثقة من كبرى العلامات التجارية وقواعد البيانات
                  الغذائية. قد تختلف القيم الفعلية بحسب الوصفة ومكان الشراء.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>استخدامات حاسبة الدونات</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  في إدارة الوزن والتغذية:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>تتبع السعرات:</strong> لمن يحسب كالوريه اليومي ضمن
                    نظام غذائي
                  </li>
                  <li>
                    <strong>مراقبة السكريات:</strong> مفيد جداً لمرضى السكري
                    وحساسية الجلوكوز
                  </li>
                  <li>
                    <strong>الموازنة الغذائية:</strong> تساعدك تعرف كم تحتاج
                    تعوّض من وجبات أخرى
                  </li>
                  <li>
                    <strong>تقليل الدهون:</strong> تكشف الفرق بين أنواع الدونات
                    لتختار الأخف
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  في المخابز والمطاعم:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>البطاقات الغذائية:</strong> إعداد بيانات تغذوية
                    للمنتجات
                  </li>
                  <li>
                    <strong>التسويق الصحي:</strong> إبراز الخيارات الأقل سعرات
                    للزبائن
                  </li>
                  <li>
                    <strong>المقارنة:</strong> مقارنة منتجات مختلفة حسب قيمتها
                    الغذائية
                  </li>
                  <li>
                    <strong>التطوير:</strong> مساعدة في تطوير وصفات أخف وأصحى
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  في الحياة اليومية:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>مشاركة العائلة:</strong> معرفة كم أكل أطفالك من
                    السعرات في الوليمة
                  </li>
                  <li>
                    <strong>المناسبات:</strong> التخطيط لكميات الدونات في
                    الحفلات
                  </li>
                  <li>
                    <strong>الفضول الغذائي:</strong> فهم ما نأكله بشكل واضح
                  </li>
                  <li>
                    <strong>الاختيار الذكي:</strong> المقارنة بين أنواع مختلفة
                    قبل الشراء
                  </li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>السعرات الحرارية في أنواع الدونات الشائعة</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  يختلف الدونات في تركيبته الغذائية اختلافاً واضحاً من نوع
                  لآخر. الدونات المحشو بالكريمة أو الجيلي يحتوي عادةً على
                  سعرات أعلى بكثير من الدونات السادة، لأن الحشوة تضيف وزناً
                  ودهوناً وسكريات إضافية. إليك مقارنة سريعة:
                </p>
                <table className="table bmi-table" style={{ marginTop: "1rem" }}>
                  <thead>
                    <tr>
                      <th
                        className="bmi-header"
                        style={{ textAlign: "center" }}
                      >
                        النوع
                      </th>
                      <th
                        className="bmi-header"
                        style={{ textAlign: "center" }}
                      >
                        الوزن التقريبي (جم)
                      </th>
                      <th
                        className="bmi-header"
                        style={{ textAlign: "center" }}
                      >
                        السعرات (سعرة)
                      </th>
                      <th
                        className="bmi-header"
                        style={{ textAlign: "center" }}
                      >
                        الدهون (جم)
                      </th>
                      <th
                        className="bmi-header"
                        style={{ textAlign: "center" }}
                      >
                        السكر (جم)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ textAlign: "center" }}>دونات سادة</td>
                      <td style={{ textAlign: "center" }}>55</td>
                      <td style={{ textAlign: "center" }}>193</td>
                      <td style={{ textAlign: "center" }}>8.3</td>
                      <td style={{ textAlign: "center" }}>6.6</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}>دونات بالجلاز</td>
                      <td style={{ textAlign: "center" }}>60</td>
                      <td style={{ textAlign: "center" }}>228</td>
                      <td style={{ textAlign: "center" }}>10.2</td>
                      <td style={{ textAlign: "center" }}>13.2</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}>دونات بالسكر</td>
                      <td style={{ textAlign: "center" }}>60</td>
                      <td style={{ textAlign: "center" }}>234</td>
                      <td style={{ textAlign: "center" }}>10.2</td>
                      <td style={{ textAlign: "center" }}>12</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}>دونات بالكريمة</td>
                      <td style={{ textAlign: "center" }}>85</td>
                      <td style={{ textAlign: "center" }}>357</td>
                      <td style={{ textAlign: "center" }}>18.7</td>
                      <td style={{ textAlign: "center" }}>21.3</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}>دونات بالجيلي</td>
                      <td style={{ textAlign: "center" }}>85</td>
                      <td style={{ textAlign: "center" }}>349</td>
                      <td style={{ textAlign: "center" }}>15.3</td>
                      <td style={{ textAlign: "center" }}>25.5</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}>دونات أولد فاشند</td>
                      <td style={{ textAlign: "center" }}>80</td>
                      <td style={{ textAlign: "center" }}>360</td>
                      <td style={{ textAlign: "center" }}>17.6</td>
                      <td style={{ textAlign: "center" }}>17.6</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}>دونات حفرة</td>
                      <td style={{ textAlign: "center" }}>25</td>
                      <td style={{ textAlign: "center" }}>93</td>
                      <td style={{ textAlign: "center" }}>4</td>
                      <td style={{ textAlign: "center" }}>4.5</td>
                    </tr>
                  </tbody>
                </table>
                <div
                  className="alert alert-success mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>✓ نصيحة:</strong> دونات الحفرة خيار ذكي لمن يريد
                  تناول الدونات بسعرات أقل. حجمه الصغير يعني جمال الطعم دون
                  الإفراط في السعرات.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>أمثلة عملية على حساب سعرات الدونات</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  مثال 1: دونات بالجلاز متوسط الحجم
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>الحالة:</strong> تناولت دونات بالجلاز واحداً صباحاً،
                  وتريد معرفة كم يمثل من احتياجك اليومي البالغ 2000 سعرة.
                </p>
                <div className="alert alert-info" style={{ fontSize: "14px" }}>
                  <strong>الحساب:</strong> وزن الدونات = 60 جم
                  <br />
                  السعرات لكل 100 جم = 380 سعرة
                  <br />
                  السعرات للقطعة = 60 × 380 / 100 = 228 سعرة
                  <br />
                  النسبة من اليوم = 228 / 2000 × 100 = 11.4%
                </div>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  مثال 2: 3 قطع دونات حفرة
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>الحالة:</strong> أكلت 3 دونات حفرة مع القهوة الصباحية.
                  كم السعرات؟
                </p>
                <div className="alert alert-info" style={{ fontSize: "14px" }}>
                  <strong>الحساب:</strong> وزن القطعة = 25 جم
                  <br />
                  السعرات للقطعة = 25 × 370 / 100 ≈ 93 سعرة
                  <br />
                  الإجمالي لـ 3 قطع = 93 × 3 = 279 سعرة
                </div>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  مثال 3: دونات بالكريمة كبير الحجم
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>الحالة:</strong> دونات بالكريمة كبير الحجم — ما مقدار
                  الدهون والسكريات فيه؟
                </p>
                <div className="alert alert-info" style={{ fontSize: "14px" }}>
                  <strong>الحساب:</strong> وزن الدونات الكبير = 85 × 1.35 ≈ 115 جم
                  <br />
                  الدهون = 115 × 22 / 100 ≈ 25.3 جم
                  <br />
                  السكريات = 115 × 25 / 100 ≈ 28.8 جم (57% من الحد اليومي!)
                </div>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  مثال 4: تخطيط وجبة دونات في حفلة أطفال
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>الحالة:</strong> تريد تقديم 20 دونات جلاز متوسط لحفلة
                  أطفال. كم إجمالي السعرات؟
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>الحل:</strong> أدخل في الحاسبة: النوع = جلاز، الحجم =
                  متوسط، العدد = 20. النتيجة: حوالي 4560 سعرة إجمالية، أي 228
                  سعرة لكل طفل إن تناول واحداً.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>نصائح للاستمتاع بالدونات بذكاء</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  نصائح عامة:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>اختر الحجم الأصغر:</strong> الدونات الصغير يعطيك
                    نفس المتعة بنصف السعرات تقريباً
                  </li>
                  <li>
                    <strong>الوقت مهم:</strong> تناوله في الصباح بعد رياضة أفضل
                    من تناوله ليلاً
                  </li>
                  <li>
                    <strong>لا تأكله وحده:</strong> إضافة بروتين كالبيض أو
                    اليوغورت يبطئ امتصاص السكر
                  </li>
                  <li>
                    <strong>الاعتدال أساس:</strong> مرة أو مرتين في الأسبوع
                    مقبول في نظام غذائي متوازن
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  أخطاء شائعة يجب تجنبها:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>ظن أن الدونات الصغير "لا يحسب" — كل سعرة تحتسب</li>
                  <li>إغفال سعرات المشروب المرافق كالقهوة المحلاة</li>
                  <li>المقارنة بين الدونات والفطائر الصحية — كلاهما من الحلويات</li>
                  <li>تناول أكثر من قطعة لأن "الحجم صغير" — الكمية تضاعف السعرات</li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  للاستخدام الاحترافي (مخابز ومطاعم):
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>استخدم خيار الوزن اليدوي لإدخال الوزن الفعلي لوصفتك</li>
                  <li>قارن بين أنواع مختلفة من الحشوات لاختيار الأخف</li>
                  <li>احسب سعرات الكمية الكاملة قبل التقديم في المناسبات</li>
                  <li>استخدم الأرقام لإعداد بطاقات تغذوية دقيقة للمنتج</li>
                </ul>
                <div
                  className="alert alert-warning mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>⚠️ تحذير:</strong> القيم الغذائية في الحاسبة هي
                  متوسطات قياسية. الدونات المصنوع في المنزل أو المخبز المحلي
                  قد يختلف حسب كميات الزبدة والسكر المستخدمة.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>معلومات مثيرة عن الدونات</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  حقائق تاريخية وغذائية:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>أصل الدونات:</strong> يُعزى ظهوره إلى المهاجرين
                    الهولنديين في أمريكا في القرن التاسع عشر
                  </li>
                  <li>
                    <strong>الثقب:</strong> تقول الرواية الشهيرة إن الربان هانسون
                    جريجوري اخترع الثقب عام 1847 لضمان طهي العجينة بالتساوي
                  </li>
                  <li>
                    <strong>يوم الدونات:</strong> أول جمعة من يونيو يُحتفل بـ
                    "اليوم الوطني للدونات" في الولايات المتحدة
                  </li>
                  <li>
                    <strong>أرقام ضخمة:</strong> يُستهلك في الولايات المتحدة
                    وحدها أكثر من 10 مليارات دونات سنوياً
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  الدونات في العالم العربي:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>انتشار واسع:</strong> أصبح الدونات من الحلويات
                    المفضلة لدى الأطفال والشباب في كل أنحاء المنطقة
                  </li>
                  <li>
                    <strong>نكهات محلية:</strong> بدأت المخابز العربية تقدم
                    دونات بنكهات محلية كالتمر والقشطة والعسل
                  </li>
                  <li>
                    <strong>مناسبات خاصة:</strong> يُقدَّم الدونات بكثرة في
                    المناسبات والولائم كحلوى سهلة الخدمة
                  </li>
                </ul>
              </div>
            </div>

            {/* FAQ Section */}
            <div className="info-section">
              <div className="info-section-header">
                <strong>الأسئلة الشائعة حول حاسبة الدونات</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "8px" }}>
                  كم سعرة في الدونات بالجلاز؟
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  الدونات بالجلاز المتوسط الحجم يحتوي على حوالي 220-240 سعرة
                  حرارية. هذا الرقم يعتمد على الوزن الفعلي، إذ يتراوح وزن
                  الدونات المتوسط بين 55 و65 جراماً. مثلاً، دونات كريسبي كريم
                  الجلاز يحتوي على 190 سعرة بينما منتج دنكن يصل إلى 240 سعرة.
                </p>

                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "8px",
                  }}
                >
                  ما الفرق بين دونات العجين المخمّر ودونات الكيك؟
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  دونات العجين المخمّر (yeast donut) أخف عموماً لأنه يحتوي على
                  فراغات هوائية تجعله أقل كثافة، وسعراته أقل من دونات الكيك
                  الأكثر كثافة ودسماً. أولد فاشند مثلاً هو نوع من دونات الكيك
                  ويحتوي على 310-350 سعرة للقطعة المتوسطة، أعلى من الدونات
                  المخمّر بالجلاز.
                </p>

                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "8px",
                  }}
                >
                  هل يمكن أكل الدونات أثناء الحمية؟
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  نعم، يمكن تناوله باعتدال ضمن أي حمية متوازنة. الأهم أن تحتسب
                  سعراته ضمن ميزانيتك اليومية. اختر الحجم الصغير أو دونات
                  الحفرة لتقليل السعرات، وتجنب الأنواع المحشوة بالكريمة إذا كنت
                  تراقب الدهون. مرة في الأسبوع لن تدمر نظامك.
                </p>

                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "8px",
                  }}
                >
                  كم جرام دهون في الدونات بالكريمة؟
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  الدونات بالكريمة المتوسط يحتوي على نحو 18-22 جرام دهون. هذا
                  يمثل تقريباً 25-28% من الحد اليومي الموصى به بالدهون (78 جم)
                  لنظام غذائي يحتوي على 2000 سعرة. الدهون المشبعة تشكل نسبة
                  كبيرة منها بسبب الكريمة المستخدمة في الحشوة.
                </p>

                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "8px",
                  }}
                >
                  ما هو الدونات الأقل ضرراً للسكري؟
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  الدونات السادة هو الأقل سكريات بين الأنواع الشائعة، إذ
                  يحتوي على 6-8 جرامات فقط من السكر مقارنة بـ 25-30 جرام في
                  الأنواع المحشوة. مع ذلك، كل أنواع الدونات تحتوي على كربوهيدرات
                  سريعة الامتصاص. يُنصح مرضى السكري باستشارة طبيبهم قبل
                  إدراج الدونات في نظامهم الغذائي.
                </p>

                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "8px",
                  }}
                >
                  كيف أحسب سعرات دونات مصنوع في المنزل؟
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  استخدم خيار "أدخل الوزن يدوياً" في الحاسبة وأدخل وزن
                  دوناتتك بالجرام. ستعطيك الحاسبة تقديراً جيداً بناءً على النوع
                  الأقرب لوصفتك. للحصول على حساب أدق، احسب سعرات كل مكون
                  (الدقيق، السكر، البيض، الزبدة، الزيت) وقسّم على عدد الدونات
                  الناتجة.
                </p>

                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "8px",
                  }}
                >
                  هل دونات الحفرة أخف سعرات من الدونات العادي؟
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  بالتأكيد، لأن وزنه أصغر بكثير. دونات الحفرة يزن 20-30 جراماً
                  فقط مقارنة بـ 55-85 جراماً للدونات العادي. لكن انتبه: إذا
                  أكلت 5 أو 6 قطع دونات حفرة، قد تتجاوز سعرات دونات واحد عادي.
                  الوعي بالكمية هو المفتاح الحقيقي.
                </p>

                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "8px",
                  }}
                >
                  هل تختلف قيم السعرات بين الماركات المختلفة؟
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  نعم، تختلف اختلافاً ملحوظاً أحياناً. مثلاً، الدونات بالجلاز
                  من كريسبي كريم يحتوي على 190 سعرة بينما نفس النوع من دنكن
                  يصل إلى 240 سعرة. هذا الفرق يعود للوزن الفعلي والمكونات
                  المستخدمة في كل وصفة. لمعرفة القيمة الدقيقة لماركة معينة،
                  راجع البيانات الغذائية الرسمية للعلامة التجارية.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DonutCalculator;